<template>
	<div class="index">
		<div class="overlay-menu">
			<div id="projets" class="tablecon">
				<div class="row th list">
					<div class="col-12 ta titlecont">Table of Contents</div>
				</div>
				<div id="table_content">
					<a v-for="item in indice" @click="turnPage(item.ref)" class="row list" >
						<div class="col-xs-6 col-sm-10"><span class="title">{{item.name}}</span></br> 
							<span class="subtitle" >{{item?.subtitle}}</span>
						</div>
						<div class="hidden-xs col-sm-2">{{item.page}}</div>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $ from "jquery";
import "@/lib/turn.min.js";
import { mapMutations } from "vuex";
import index from "./index.json"

export default {
	data() {
		return {
			indice:[]			
		};
	},
	created(){
		this.indice = index
	},
	methods: {
		turnPage(num) {
			$(".flipbook").turn("page", num);
			this.setClass(false);
		},
		...mapMutations("magazine", ["setClass"]),
	},
};
</script>

<style lang="scss">
.overlay-menu {
	position: absolute;
	background: white;
	width: 100%;
	height: 100%;
	z-index: 10000;
	overflow-x: hidden;
	overflow-y: scroll;
	top: 0px;
}

#projets .th.row.list div:last-child,
#projets a.row.list div:last-child {
	text-align: right;
	font-family: "CaslonOldFace";
}

#projets .row.list div:first-child {
	display: inline;
	font-family: "CaslonOldFace";
}

#projets .row.th div {
	font-weight: 600;
	color: rgba(10, 0, 30, 0.26);
	text-transform: uppercase;
	font-size: 0.8em;
	letter-spacing: 0.1em;
	margin-left: -10%;
}

#projets .row.list div {
	padding-top: 0.6em;
	padding-bottom: 0.6em;
	font-weight: 200;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	margin: 0;
	.title{
		font-size: 1.3em;		
	}
	.subtitle{
		font-size: 1.1em;		

	}
}

.tablecon {
	padding:10% 15%;

	a {
		text-decoration: none;
		color: black;
		opacity: 0.5;
		cursor: pointer;
	}

	a:hover {
		color: black;
		font-weight: 900;
		opacity: 5;
		font-size: 1.2em;
		line-height: 1.1em;
	}
	@media screen and (max-width:767px) {
		padding:10% 2%;		
	}
}

.titlecont {
	font-size: x-large !important;
	padding-bottom: 75px !important;
	text-align: center !important;
}
@media screen and (max-width:767px) {
	.tablecon {
		padding:10% 5%;	
	}

	.titlecont {
		padding: 55px  0 !important ;
	}	
	#projets .row.list div {
		padding-top: 0.4em;
		padding-bottom: 04px;
		font-weight: 200;
		line-height:1em;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		margin: 0;
		.title{
		font-size: 0.9em;		
		}
		.subtitle{
			font-size: 0.7em;		

		}
	}
	.hidden-xs{
		display: none;
	}
	
}


</style>
